export const CONTEXT_TYPE = {
    LUBES: 'LUBES',
    FUEL: 'FUEL',
};
